var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"g-background-primary py-16 nodes-faq-container"},[_c('div',{staticClass:"content-container py-8"},[_c('SFaqList',{attrs:{"slug":"node-page-faqs"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }